import React from "react"
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createItem } from 'redux/erp/itemSlice';
import { toast } from "react-toastify";
import PropTypes from 'prop-types';
import { ERP_ITEM_UNIT } from "app_config";
import Select from 'react-select';
import { Modal, Button, FormRow } from 'components/common';

import { INPUT_CLS } from 'helpers/formStyles';
const ItemForm = ({ open, setOpen, title }) => {
  const { control, register, handleSubmit, formState: { errors } } = useForm();

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(createItem(data)).unwrap();
      const itemId = response?.data.id;

      if (itemId) {
        closeModal();
        toast.success(`${data.code} created successfully.`);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to create item.");
    }
  };

  const closeModal = () => setOpen(false);

  const unitOptions = ERP_ITEM_UNIT.map(unit => ({ value: unit, label: unit }));

  return (
    <Modal
      show={open}
      onHide={closeModal}
      backdropClick={false}
      title={title}
      footer={
        <div className="tw-flex tw-justify-end tw-gap-2">
          <Button variant="danger" size="sm" onClick={closeModal}>Cancel</Button>
          <Button variant="primary" size="sm" onClick={handleSubmit(onSubmit)}>Create</Button>
        </div>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Code" required error={errors.code?.message}>
          <input
            type="text"
            placeholder="Code"
            className={INPUT_CLS}
            {...register("code", { required: "Item code is required." })}
          />
        </FormRow>

        <FormRow label="Name" required error={errors.name?.message}>
          <input
            type="text"
            placeholder="Name"
            className={INPUT_CLS}
            {...register("name", { required: "Name is required." })}
          />
        </FormRow>

        <FormRow label="Unit" required error={errors.unit?.message}>
          <Controller
            control={control}
            name="unit"
            rules={{ required: { value: true, message: 'Unit is required' } }}
            render={({ field }) => (
              <Select
                {...field}
                options={unitOptions}
                value={unitOptions.find(option => option.value === field.value)}
                placeholder="Select..."
                classNamePrefix="react-select"
                onChange={(selectedOption) => field.onChange(selectedOption.value)}
              />
            )}
          />
        </FormRow>
      </form>
    </Modal>
  )
};

ItemForm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default ItemForm;
